import React from 'react'
import { useSelector } from 'react-redux'

import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { selectCurrentTicketLinkedIssuesById } from 'ducks/integrations/linear'

import LinkedResourceActions from 'components/integrations/LinkedResourceActions'
import LinkedLinearIssueFields from './LinkedLinearIssueFields'
import { useLinearIssueActions } from './hooks'

export default function LinkedLinearIssue({
  className,
  doNavigatableClearState,
  navigatableState: issueId,
}) {
  const issue = useSelector(selectCurrentTicketLinkedIssuesById)[issueId]
  const actions = useLinearIssueActions(issue, doNavigatableClearState)
  const { externalId, id, title } = issue || {}

  if (!issue) return null
  return (
    <NavigatableIntegrationWidgetCard.Detail
      className={className}
      onBack={doNavigatableClearState}
      title={title}
    >
      <LinkedLinearIssueFields issue={issue} />
      <LinkedResourceActions id={id || externalId} actions={actions} />
    </NavigatableIntegrationWidgetCard.Detail>
  )
}
